import { Link } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import { isTruthy } from "../../utils/isTruthy";
import { buildNavigationTree } from "../../utils/navigation";
export default function Footer(props) {
    var items = buildNavigationTree(props.footerNavigation.items.filter(isTruthy));
    var legalItems = buildNavigationTree(props.legalNavigation.items.filter(isTruthy));
    var year = new Date().getFullYear();
    var footerText = "\xa9 KNIME ".concat(year, ". All rights reserved");
    return /*#__PURE__*/ React.createElement("footer", {
        id: "footer",
        className: "relative z-10 bg-gray-600 text-white pt-14 md:pt-14 xl:pt-20 overflow-hidden"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "sr-only"
    }, "Footer"), /*#__PURE__*/ React.createElement("div", {
        className: "max-w-7xl mx-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto px-6 md:px-10 lg:px-14 pb-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "xl:flex mb-2.5 xl:mb-8 text-[15px] 1.5lg:text-lg"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "/",
        className: "pr-20 xl:pr-16 mb-28 md:mb-12 xl:mb-0 block focus-white"
    }, /*#__PURE__*/ React.createElement("img", {
        width: "109",
        height: "28",
        src: "/images/white-logo.png",
        alt: "KNIME logo",
        className: "max-w-full w-24 md:w-32 h-auto shrink-0",
        loading: "lazy"
    })), /*#__PURE__*/ React.createElement("ul", {
        className: 'w-full md:grid grid-contain md:grid-cols-[auto_auto_auto_auto_auto] md:grid-rows-[auto_auto] md:gap-x-4 xl:gap-x-0 md:gap-y-8 md:flex-wrap justify-between relative before:md:content-[""] before:md:block before:md:h-px before:md:w-full before:md:bg-gray-100 before:md:absolute before:md:top-8 before:md:left-0 before:xl:hidden',
        "aria-label": "Footer"
    }, items.map(function(item, key) {
        return /*#__PURE__*/ React.createElement("li", {
            key: key + "header",
            className: clsx("block xl:border-l xl:border-l-gray-150 xl:pl-3 xl:pr-4 mb-12 md:mb-0", {
                "row-[1/3]": key === 0 || key === 1 || key === 2 || key === 5,
                "row-[1/2]": key === 3,
                "row-[2/3] footer-item-sm": key === 4,
                "col-[1/2]": key === 0,
                "col-[2/3]": key === 1,
                "col-[3/4]": key === 2,
                "col-[4/5]": key === 3 || key === 4,
                "col-[5/6]": key === 5
            })
        }, item.target ? /*#__PURE__*/ React.createElement(Link, {
            href: item.target,
            className: "text-gray-100 focus-white block mb-3 md:mb-4 lg:mb-5 pb-1.5 md:pb-3 xl:pb-0 border-b border-b-gray-100 md:border-0"
        }, item.title) : /*#__PURE__*/ React.createElement("span", {
            className: "text-gray-100 focus-white block mb-3 md:mb-4 lg:mb-5 pb-1.5 md:pb-3 xl:pb-0 border-b border-b-gray-100 md:border-0"
        }, item.title), item.children.length !== 0 ? /*#__PURE__*/ React.createElement("ul", null, item.children.map(function(child, key) {
            return /*#__PURE__*/ React.createElement("li", {
                key: key
            }, child.target ? /*#__PURE__*/ React.createElement(Link, {
                href: child.target,
                className: "text-white focus-white hover:text-orange-500 transition-all text-sm 1.5lg:text-base block mb-3"
            }, child.title) : /*#__PURE__*/ React.createElement("span", {
                className: "text-white transition-all text-sm 1.5lg:text-base block mb-3"
            }, child.title), child.children.length !== 0 ? /*#__PURE__*/ React.createElement("ul", {
                className: "-mt-0.5 mb-3 md:mb-2.5 lg:mb-4"
            }, child.children.map(function(grandchild) {
                return /*#__PURE__*/ React.createElement("li", {
                    key: grandchild.title
                }, grandchild.target ? /*#__PURE__*/ React.createElement(Link, {
                    href: grandchild.target,
                    className: "text-gray-300 focus-white hover:text-orange-500 transition-all text-xs 1.5lg:text-sm block ml-1.5 leading-relaxed mb-0.5 lg:mb-1.5"
                }, grandchild.title) : null);
            })) : null);
        })) : null);
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: 'flex justify-end items-center xl:relative after:xl:content-[""] after:xl:block after:xl:w-1/2 after:xl:bg-gray-900 after:xl:h-10 after:xl:absolute after:xl:right-0 after:xl:top-0'
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto md:px-10 lg:px-14 md:max-w-7xl w-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "bg-gray-900 py-2.5 md:px-20"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:flex md:justify-between md:items-center text-xs lg:text-sm xl:relative xl:z-10 max-w-3xl"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex text-center absolute top-[130px] md:top-16 left-6 md:left-[unset] md:right-14 xl:static xl:mr-[2%]"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "https://www.linkedin.com/company/knime",
        className: "block text-white focus-white transition-all hover:text-orange-500 mr-3 xl:mr-3"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "LinkedIn"), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        className: "w-3 h-3 block"
    }, /*#__PURE__*/ React.createElement("title", null, "LinkedIn"), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M11 13.75V9.362C11 8.317 10.933 7 9.499 7 8 7 7.821 8.112 7.821 9.287v4.463H5V4.737h2.71V6h.039C8.122 5.258 9 4.51 10.397 4.51c2.832 0 3.353 1.866 3.353 4.289v4.951zM1.87 3.507C1 3.507.25 2.767.25 1.871.25 1 1 .25 1.87.25c.896 0 1.622.75 1.622 1.621 0 .895-.726 1.636-1.621 1.636zM3.273 13.75H.473V4.737h2.799z"
    }))))), /*#__PURE__*/ React.createElement("a", {
        href: "https://www.youtube.com/user/KNIMETV",
        className: "block text-white focus-white transition-all hover:text-orange-500 mr-3 xl:mr-3"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "YouTube"), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18px",
        height: "13px",
        viewBox: "0 0 18 13",
        version: "1.1",
        className: "w-3 h-3 block"
    }, /*#__PURE__*/ React.createElement("title", null, "YouTube"), /*#__PURE__*/ React.createElement("g", {
        id: "Symbols",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Footer/Desktop",
        transform: "translate(-235.6592, -801.6667)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Footer",
        transform: "translate(0, 240)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Section/Sub-Footer",
        transform: "translate(73, 549)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Content",
        transform: "translate(91, 5)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "icon-youtube-white",
        transform: "translate(66, 0)"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "30",
        height: "30"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M23.2830947,10.7007265 C23.0760796,9.90007549 22.4661414,9.26950778 21.691705,9.05551559 C20.2879836,8.66666663 14.6592222,8.66666663 14.6592222,8.66666663 C14.6592222,8.66666663 9.03049369,8.66666663 7.6267393,9.05551559 C6.85230299,9.26954163 6.24236477,9.90007549 6.03534965,10.7007265 C5.65922217,12.1519531 5.65922217,15.179802 5.65922217,15.179802 C5.65922217,15.179802 5.65922217,18.207651 6.03534965,19.6588776 C6.24236477,20.4595286 6.85230299,21.0638255 7.6267393,21.2778177 C9.03049369,21.6666666 14.6592222,21.6666666 14.6592222,21.6666666 C14.6592222,21.6666666 20.2879507,21.6666666 21.691705,21.2778177 C22.4661414,21.0638255 23.0760796,20.4595286 23.2830947,19.6588776 C23.6592222,18.207651 23.6592222,15.179802 23.6592222,15.179802 C23.6592222,15.179802 23.6592222,12.1519531 23.2830947,10.7007265 Z M12.8183003,17.9288619 L12.8183003,12.4307422 L17.5228271,15.1798698 L12.8183003,17.9288619 Z",
        id: "Icon",
        fill: "currentColor",
        fillRule: "nonzero"
    }))))))))), /*#__PURE__*/ React.createElement("a", {
        href: "https://medium.com/low-code-for-advanced-data-science",
        className: "block text-white focus-white transition-all hover:text-orange-500"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Medium"), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "w-3 h-3 block",
        width: "21px",
        height: "12px",
        viewBox: "0 0 21 12",
        version: "1.1"
    }, /*#__PURE__*/ React.createElement("title", null, "Medium"), /*#__PURE__*/ React.createElement("g", {
        id: "Symbols",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Footer/Desktop",
        transform: "translate(-267, -802)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Footer",
        transform: "translate(0, 240)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Section/Sub-Footer",
        transform: "translate(73, 548)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Content",
        transform: "translate(91, 5)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "icon-medium-white",
        transform: "translate(99, 0)"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "30",
        height: "30"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "Logo/Medium-Icon",
        transform: "translate(4, 9)",
        fill: "#FFFFFF",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M11.8452308,5.99989882 C11.8452308,9.3135929 9.1935836,12 5.92251484,12 C2.65144608,12 0,9.31440231 0,5.99989882 C0,2.68539534 2.65164719,0 5.92251484,0 C9.19338249,0 11.8452308,2.68620475 11.8452308,5.99989882 M18.3425206,5.99989882 C18.3425206,9.11933629 17.0165964,11.6479099 15.3811626,11.6479099 C13.7457288,11.6479099 12.4198046,9.11852689 12.4198046,5.99989882 C12.4198046,2.88127076 13.7457288,0.351887763 15.3811626,0.351887763 C17.0165964,0.351887763 18.3425206,2.88127076 18.3425206,5.99989882 M21,5.99989882 C21,8.79476586 20.5336238,11.0602836 19.9584467,11.0602836 C19.3832695,11.0602836 18.9168933,8.79395646 18.9168933,5.99989882 C18.9168933,3.20584119 19.3832695,0.939514021 19.9586478,0.939514021 C20.534026,0.939514021 21,3.20523414 21,5.99989882",
        id: "Icon",
        fill: "currentColor"
    })))))))))), /*#__PURE__*/ React.createElement("a", {
        href: "https://bsky.app/profile/knime.bsky.social",
        className: "block text-white focus-white transition-all hover:text-orange-500"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Bluesky"), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "w-3 h-3 block ml-3",
        viewBox: "0 0 512 512"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Symbols",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Footer/Desktop",
        transform: "translate(-267, -802)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Footer",
        transform: "translate(0, 240)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Section/Sub-Footer",
        transform: "translate(73, 548)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Content",
        transform: "translate(91, 5)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "icon-bluesky-white",
        transform: "translate(99, 0)"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "30",
        height: "30"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "Logo/Instagram-Icon",
        transform: "translate(4, 9)",
        fill: "#FFFFFF",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M111.8 62.2C170.2 105.9 233 194.7 256 242.4c23-47.6 85.8-136.4 144.2-180.2c42.1-31.6 110.3-56 110.3 21.8c0 15.5-8.9 130.5-14.1 149.2C478.2 298 412 314.6 353.1 304.5c102.9 17.5 129.1 75.5 72.5 133.5c-107.4 110.2-154.3-27.6-166.3-62.9l0 0c-1.7-4.9-2.6-7.8-3.3-7.8s-1.6 3-3.3 7.8l0 0c-12 35.3-59 173.1-166.3 62.9c-56.5-58-30.4-116 72.5-133.5C100 314.6 33.8 298 15.7 233.1C10.4 214.4 1.5 99.4 1.5 83.9c0-77.8 68.2-53.4 110.3-21.8z"
    })))))))))), /*#__PURE__*/ React.createElement("a", {
        href: "https://www.instagram.com/knimesoftware/",
        className: "block text-white focus-white transition-all hover:text-orange-500"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Instagram"), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "w-3 h-3 block ml-3",
        width: "21px",
        height: "13px",
        viewBox: "0 0 448 512",
        version: "1.1"
    }, /*#__PURE__*/ React.createElement("title", null, "Instagram"), /*#__PURE__*/ React.createElement("g", {
        id: "Symbols",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Footer/Desktop",
        transform: "translate(-267, -802)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Footer",
        transform: "translate(0, 240)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Section/Sub-Footer",
        transform: "translate(73, 548)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Content",
        transform: "translate(91, 5)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "icon-instagram-white",
        transform: "translate(99, 0)"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "30",
        height: "30"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "Logo/Instagram-Icon",
        transform: "translate(4, 9)",
        fill: "#FFFFFF",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
    }))))))))))), /*#__PURE__*/ React.createElement("div", {
        className: "triangle-before relative pl-6 md:pl-0 mr-[3%] md:mr-[6%] text-gray-200 md:text-left md:inline-block mb-3.5 md:mb-0"
    }, footerText), /*#__PURE__*/ React.createElement("div", {
        className: "pl-6 md:pl-0 md:flex md:justify-between"
    }, /*#__PURE__*/ React.createElement("nav", {
        className: "md:inline-block"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "md:text-left md:flex md:flex-wrap w-full"
    }, legalItems.map(function(legalItem, key) {
        return /*#__PURE__*/ React.createElement("li", {
            key: key,
            className: "block md:inline-block mb-1.5 md:mb-0"
        }, legalItem.target ? /*#__PURE__*/ React.createElement(Link, {
            href: legalItem.target,
            className: "focus-white hover:text-white text-gray-300 transition-all md:pl-7"
        }, legalItem.title) : null);
    })))))))));
}
